module.exports = __webpack_public_path__ + "static/media/ishogroupe.347db60a.png";